module.exports = __webpack_public_path__ + "img/logout.00df6086.svg";